import React, { useState, useRef, useEffect } from "react";
import raymond from "./../assets/resources/team/raymond_chan.jpg";
import lion from "./../assets/resources/team/lion7.png";
import paris from "./../assets/resources/team/paris_forino2.png";
import sunlight from "./../assets/resources/team/sunlight_logo.png";
import icross from "./../assets/resources/team/icross_logo.png";
import bsquare2 from "./../assets/resources/team/b_square_logo.png";
import bsquare3 from "./../assets/resources/team/barbie_li_logo.png";
import "./building_page.css";
import { Helmet } from "react-helmet";

export default function Team() {
  const [isScrolledToSection, setIsScrolledToSection] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
  });

  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);
  const section5Ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting) {
            setIsScrolledToSection((prev) => ({
              ...prev,
              [id.replace("section", "section")]: true,
            }));
          }
        });
      },
      {
        root: null,
        rootMargin: "-20% 0px -20% 0px",
        threshold: 0.2,
      }
    );

    const sections = [
      section1Ref,
      section2Ref,
      section3Ref,
      section4Ref,
      section5Ref,
    ];
    sections.forEach((sectionRef) => {
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
    });

    return () => {
      sections.forEach((sectionRef) => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      });
    };
  }, []);
  return (
    <>
      <Helmet>
        <title>Meet the Team | Union Center - Flushing, NY</title>
        <meta
          name="description"
          content="Meet the visionary team behind Union Center - featuring Lions Group NYC, Raymond Chan Architect PC, Paris Forino, and other industry leaders bringing luxury office space to Flushing."
        />
        <meta
          name="keywords"
          content="Union Center development team, Lions Group NYC, Raymond Chan Architect, Paris Forino, Flushing real estate developers"
        />
        <link rel="canonical" href="https://www.3716union.com/team" />
      </Helmet>
      <div className="flex flex-col w-full mx-auto bg-white">
        <div className="w-full text-[#00000] text-base  bg-white mt-40">
          <section className="md:flex w-full max-w-[1250px] mx-auto">
            <div className="flex w-full">
              <div className="w-full max-w-[1250px] mx-auto md:py-[60px] pb-5 pt-10 text-left px-4">
                <p className="text-lg text-[#b98953]">BEHIND IT ALL</p>
                <p className="text-[#7e6140] text-4xl md:text-6xl tracking-wide font-normal pb-1">
                  Meet the Visionary Team <br className="hidden md:block" />
                  Behind Union Center
                </p>
              </div>
            </div>
          </section>
          <section className="md:flex w-full bg-[#F0EDE8]">
            <div className="flex w-full">
              <div className="w-full max-w-[800px] mx-auto md:py-[60px] pb-8 pt-10 md:text-center px-4">
                <p className={" max-w-[980px]  text-lg text-[#b98953]"}>
                  DEVELOPER
                </p>

                <img
                  src={lion}
                  alt="Team member 1"
                  className="max-w-[300px] mx-auto my-10 object-cover"
                />

                <p>
                  With over three decades of experience and knowledge in
                  residential and commercial real estate development, Lions
                  Group NYC has risen as one of the most premier developers
                  serving New York with a portfolio valued over $150 Million.
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className="w-full text-[#00000] text-base">
          <section className="md:flex w-full mt-20 mx-auto max-w-[1250px]">
            <div className="relative w-full px-4 md:flex">
              <div
                ref={section1Ref}
                id="section1"
                className="top-[40px] absolute"
              ></div>
              <div
                className={`w-full text-base text-left md:text-right ml-auto  pr-0 md:pr-10 my-auto object-cover ${
                  isScrolledToSection.section1
                    ? "top-0 opacity-100 transform translate-y-0"
                    : "top-[270px] opacity-0 transform translate-y-20"
                } transition-all duration-1000 ease-out`}
              >
                <img
                  src={raymond}
                  alt="Team member 1"
                  className={`w-full mb-7 md:hidden object-cover`}
                />
                <p className={" max-w-[980px] ml-1 text-lg text-[#b98953]"}>
                  ARCHITECT
                </p>

                {/* <div ref={section1Ref} id="section1"></div> */}
                <h2 className="  text-[#7e6140] mt-3 text-4xl">
                  Raymond Chan Architect PC
                </h2>

                <p className=" max-w-[980px] contrast-[21] mt-[24px] text-md text-[#00000]">
                  Raymond Chan Architect PC was founded in 1986. The firm is
                  licensed to practice architecture in the states of New York,
                  New Jersey, Maryland, Pennsylvania, Nevada, and Georgia. Their
                  extensive experience has allowed them to gain proficiency in
                  all elements of design. However, Raymond Chan Architect is
                  best known for their crisp and spatially clean contemporary
                  style. Throughout the past decade, they have won numerous
                  design awards around the tri-state area. They offer their
                  clients stylish yet functional designs that adapt with the
                  rapidly evolving world.
                </p>
              </div>
              <div className="relative flex items-center justify-center w-full h-full ease-linear pointer-events-auto ">
                <img
                  src={raymond}
                  alt="Team member 1"
                  className={`w-full hidden md:block pl-3 object-cover ${
                    isScrolledToSection.section1
                      ? "top-0 opacity-100 transform translate-y-0"
                      : "top-[270px] opacity-0 transform translate-y-20"
                  } transition-all duration-1000 ease-out delay-200`}
                />
              </div>
            </div>
          </section>

          <section className="md:flex w-full max-w-[1250px] mt-12 mx-auto">
            <div className="relative w-full px-4 md:flex">
              <div
                ref={section2Ref}
                id="section2"
                className="top-[40px] absolute"
              ></div>

              <div className="relative justify-center w-full ease-linear pointer-events-auto pr md:pr-10">
                {/* <div
                  ref={section2Ref}
                  id="section2"
                  className="absolute top-[240px]"
                ></div> */}

                <img
                  src={paris}
                  alt="Team member 2"
                  className={`w-full object-cover ${
                    isScrolledToSection.section2
                      ? "top-0 opacity-100 transform translate-y-0"
                      : "top-[270px] opacity-0 transform translate-y-20"
                  } transition-all duration-1000 ease-out`}
                />
              </div>
              <div
                className={`w-full text-base ml-auto  pl-0 md:pl-3 my-auto object-cover ${
                  isScrolledToSection.section2
                    ? "top-0 opacity-100 transform translate-y-0"
                    : "top-[270px] opacity-0 transform translate-y-20"
                } transition-all duration-1000 ease-out`}
              >
                <p
                  className={
                    "max-w-[980px]  mt-4 md:mt-0 text-lg text-[#b98953]"
                  }
                >
                  INTERIOR DESIGNER
                </p>
                {/* <div ref={section1Ref} id="section1"></div> */}
                <h2 className=" max-w-[980px] text-[#7e6140] mt-3 pb-[12px] text-4xl">
                  Paris Forino
                </h2>
                <p className=" max-w-[980px] contrast-[21] text-md text-[#00000]">
                  Paris Forino has developed a reputation for creating interiors
                  of timeless elegance and understated luxury infused with
                  beauty, light and harmony. The firm creates fully conceived
                  and exquisitely executed spaces marked by thoughtful
                  consideration of proportion, purpose and emotional experience.
                  Rich details, historical features and clean lines complement a
                  multifaceted and inspired choice of palette, material and
                  texture to result in gorgeous interiors that surprise and
                  delight.
                </p>
              </div>
            </div>
          </section>

          <section className="md:flex w-full mt-20 md:mt-16 mx-auto max-w-[1250px]">
            <div className="relative w-full px-4 md:flex">
              <div
                ref={section3Ref}
                id="section3"
                className="top-[40px] absolute"
              ></div>
              <div
                className={`w-full text-base text-left md:text-right ml-auto pr-0 md:pr-10 object-cover ${
                  isScrolledToSection.section3
                    ? "top-0 opacity-100 transform translate-y-0"
                    : "top-[270px] opacity-0 transform translate-y-20"
                } transition-all duration-1000 ease-out my-auto`}
              >
                <img
                  src={sunlight}
                  alt="Team member 3"
                  className={`max-w-[300px] md:hidden mb-7 mx-auto w-full object-cover relative`}
                />
                <p className="max-w-[980px] text-lg text-[#b98953]">
                  PARTNER DEVELOPER
                </p>
                <h2 className="text-[#7e6140] mt-3 text-4xl">
                  Sunlight Development
                </h2>
                <p className="max-w-[980px] contrast-[21] mt-[24px] text-md text-[#00000]">
                  Sunlight Development has completed more than 2 million square
                  feet since its founding in 2002. Specializing in ground-up
                  condominium, multi-family, and office projects, Sunlight’s
                  offerings include general contracting, construction
                  management, and consulting services.
                </p>
              </div>
              <div className="flex items-center justify-center w-full h-full">
                <img
                  src={sunlight}
                  alt="Team member 3"
                  className={`max-w-[300px] hidden md:block  pl-3 object-cover ${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100 transform translate-y-0"
                      : "top-[270px] opacity-0 transform translate-y-20"
                  } transition-all duration-1000 ease-out delay-200`}
                />
              </div>
            </div>
          </section>

          <section className="md:flex w-full max-w-[1250px] pb-8 mt-6 md:mt-16 mx-auto">
            <div className="relative w-full px-4 md:flex">
              <div
                ref={section4Ref}
                id="section4"
                className="top-[40px] absolute"
              ></div>

              <div className="relative flex items-center justify-center w-full h-full ease-linear opacity-100 pointer-events-auto transform-none duration-40">
                {/* <div
                  ref={section4Ref}
                  id="section4"
                  className="absolute top-[240px]"
                ></div> */}

                <img
                  src={icross}
                  alt="Team member 1"
                  className={`max-w-[260px] my-10 object-cover ${
                    isScrolledToSection.section4
                      ? "top-0 opacity-100 transform translate-y-0"
                      : "top-[270px] opacity-0 transform translate-y-20"
                  } transition-all duration-1000 ease-out`}
                />
              </div>
              <div
                className={`w-full text-base ml-auto pl-0 md:pl-7 my-auto ${
                  isScrolledToSection.section4
                    ? "top-0 opacity-100 transform translate-y-0"
                    : "top-[270px] opacity-0 transform translate-y-20"
                } transition-all duration-1000 ease-out`}
              >
                <p className={"max-w-[980px] -mt-1 text-lg text-[#b98953]"}>
                  FINANCE PARTNER
                </p>
                {/* <div ref={section1Ref} id="section1"></div> */}
                <h2 className=" max-w-[980px] text-[#7e6140] mt-3 pb-[12px] text-4xl">
                  iCross Capital
                </h2>
                <p className=" max-w-[980px] contrast-[21] text-md text-[#00000]">
                  The Union Center development project is financed by iCross
                  Capital, a prominent real estate investment firm specializing
                  in providing debt and equity financing to developers across
                  the United States, with a particular focus on the Greater New
                  York area. Under the leadership of real estate entrepreneur
                  Lily Guo, iCross has established itself as a well-recognized
                  private lender in New York City's commercial real estate
                  industry.
                </p>
              </div>
            </div>
          </section>
          <section className="md:flex w-full bg-[#F0EDE8] mt-14 pb-12 pt-3 md:pt-0 md:pb-0 relative">
            <div className="flex w-full">
              <div
                ref={section5Ref}
                id="section5"
                className="absolute top-0 left-0 w-full h-20"
              ></div>
              <div
                className={`w-full max-w-[800px] mx-auto md:py-[60px] pt-7 md:pt-10 md:text-center px-4 
                  ${
                    isScrolledToSection.section5
                      ? "opacity-100 transform translate-y-0"
                      : "opacity-0 transform translate-y-20"
                  } transition-all duration-1000 ease-out`}
              >
                <p className="max-w-[980px] text-lg text-[#b98953] mb-3">
                  SALES TEAM
                </p>

                <div className="flex flex-col sm:flex-row justify-center px-2 md:px-0 items-center gap-4 w-full mb-3">
                  <img
                    src={bsquare2}
                    alt="Team member 2"
                    className="w-full sm:w-1/2 max-w-[250px] h-auto object-cover"
                  />
                  <img
                    src={bsquare3}
                    alt="Team member 3"
                    className="w-full sm:w-1/2 max-w-[250px] h-auto object-cover"
                  />
                </div>

                <p>
                  Barbie Li, an award-winning broker in New York, founded B
                  Square Realty and oversees an impressive range of listings and
                  new development projects. Her portfolio includes exclusive
                  properties across NYC and Long Island. B Square Realty has
                  successfully handled over $550 million in development projects
                  and sales volume in 2023 alone, cementing its status as a
                  leader in the industry.
                  <br />
                  <br /> B Square Realty is renowned for its expertise in new
                  development sales and international buyer platforms. The
                  company offers exclusive access to premium properties and
                  delivers personalized service to clients worldwide. With a
                  reputation for excellence and a deep understanding of the
                  market, B Square Realty is a trusted partner in the dynamic
                  New York real estate scene.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
